<template>
  <div>
    <headers :tabIndex="1"></headers>
      <div class="banner-box">
          <template v-if="bannerIndex==1">
            <p>预应力工程全数量检测系统<br />（PCS-UM20）</p>

            <img src="@/assets/imgs/product/1.png" />
          </template>
          <template v-if="bannerIndex==4">
            <p>智能拉拔系统<br />（ PT-20M）</p>
            <img style="" src="@/assets/imgs/product/2.png" />
          </template>
          <template v-if="bannerIndex==2">
            <p>锚下预应力检测系统<br />（PT-20S）</p>
            <img style=""  src="@/assets/imgs/product/3.png" />
          </template>
          <template v-if="bannerIndex==3">
            <p >预应力锚索基础试验系统<br />（ PT-20C）</p>
            <img style=""  src="@/assets/imgs/product/4.png" />
          </template>
          <template v-if="bannerIndex==5">
            <p>远程监测系统<br />（JD-FAST21）</p>
            <img style=" "  src="@/assets/imgs/product/5.png" />
          </template>
      </div>


    <div class="product1">
        <div class="p2">
          <div class="title">产品定位</div>
            <template v-if="bannerIndex==1">
              面向基建领域的预应力工程提供基于物联网智能感知、大数据分析决策、云平台智慧协同的数字化施工质量监测与管控解决方案。
            </template>
            <template v-if="bannerIndex==2">
              一种用于工后检测的锚下有效预应力检测设备。
            </template>
            <template v-if="bannerIndex==3">
              一款经典的预应力锚索基础类试验系统。
            </template>
            <template v-if="bannerIndex==4">
              一款先进的预应力锚索拉拔设备。
            </template>
            <template v-if="bannerIndex==5">
              一款通用化的岩土工程传感器远程采集传输设备。
            </template>


          <div class="title">目标客户</div>
            <template v-if="bannerIndex==1">
              业主、行业主管机构、总承包、大型监理单位、检测单位 。
            </template>
            <template v-if="bannerIndex==2">
              检测单位、施工单位、研究机构、行业主管部门。
            </template>
            <template v-if="bannerIndex==3">
              检测单位、研究机构、咨询机构、施工单位。
            </template>
            <template v-if="bannerIndex==4">
              检测单位、研究机构、施工单位、监理单位。
            </template>
            <template v-if="bannerIndex==5">
              研究机构、试验监测机构、施工单位、系统集成商。
            </template>

          <div class="title">产品简介</div>
            <template v-if="bannerIndex==1">
              基于施工机械作业信息等大数据，融合感知层、传输层、平台层和应用层等软硬件设施设备，构建而成的可视化平台型质量解决方案。
            </template>
            <template v-if="bannerIndex==2">
              当前检测行业中技术原理最先进（第 4 代）、检测速度最快、性能可靠性最好、智能化程度最高的专用设备，通过 1 5 年的
              持续研发迭代，有效解决了“检不了、检不准、检得慢”等问题。
            </template>
            <template v-if="bannerIndex==3">
              基于经典力学原理，采用高精度传感器，结合先进数据采集和测控技术，实现预应力锚索基础试验自动化采集、分析和评价。十余年来，被广泛应用于预应力领域相关研究及试验检测。
            </template>
            <template v-if="bannerIndex==4">
              当前最先进的预应锚索拉拔系统，以传感器测量和伺服闭环控制技术形成的智能油泵，根据锚固体系预应力施加要求，灵活搭配千斤顶和夹具，实现各类预应力筋拉拔过程中全自动操作。有效解决了传统拉拔类产品“手摇式”操作、人工测量、记录存在的粗放和低效问题。
            </template>
            <template v-if="bannerIndex==5">
              基于低功耗并行采样技术，自主研发设计的一款用于监测类传感器的无线自动采集传输设备。
            </template>
        </div>
      </div>

    <div class="product2">
      <div class="header-title">核心功能</div>
      <div class="header-gong">
        <template v-if="bannerIndex==1">
<!--          <img style="width: 100%" src="@/assets/imgs/product/7.png" />-->
          基于施工作业大数据等信息，通过物联网智能感知、大数据分析决策、云平台智慧协同，实现施工全景展示、智能监管预警、在线指挥调度以及专项咨询决策。
        </template>
        <template v-else-if="bannerIndex==2">
          基于预应力锚固接触力学理论，针对锚固体系中锚固单元状态跟踪技术，通过对施加预应力后的预应力筋进行反向加载，并准确捕捉锚固临界点进行锚下有效预应力的测定。
        </template>
        <template v-else-if="bannerIndex==3">
          根据预应力工程学和材料力学原理，采用高精度传感器，结合数据采集和测量控制技术，以简洁灵活的功能配置，实现各类试验过程
          中的“荷载 - 位移”参数的连续动态测试和自动采集。
        </template>
        <template v-else-if="bannerIndex==4">
          基于锚索预应力作用机理与过程分析，根据锚固体系工作原理，综合运用传感器测量和伺服闭环控制技术，通过对工艺参数的标准化和操作过程自动化，实现预应力拉拔的智能化施工或试验作业。
        </template>
        <template v-else-if="bannerIndex==5">
          <div style="text-align: center;position: relative;margin: 0.4rem 0">
            <span class="product2-index6" style="position: absolute;left: 0rem;top: 0.4rem;">自动采集</span>
            <img style="width: 4.5rem;" src="@/assets/imgs/product/6.png" />
            <span class="product2-index6" style="position: absolute;right: 0rem;top: 0.4rem;">无线传输</span>
          </div>

        </template>
      </div>

      <div class="" style="margin: 0.6rem auto">
        <div class="header-title">产品优势</div>
        <div class="product2-ul">
          <template v-if="bannerIndex==1">
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/1-1.png" />
              <p>全数量</p>
              <span>从抽样检测转变为全样监控，可掌握每项工程或工序的具体情况，将质量控制由“抽样评价”变为“100% 掌握”。</span>
            </div>
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/1-2.png" />
              <p>全过程</p>
              <span>从事后检测转变为事中控制，在过程中实时分析并及时预警，将质量问题由“隐蔽”变为“透明”。</span>
            </div>
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/1-3.png" />
              <p>数字化</p>
              <span>基于施工作业大数据等信息，有机融合每一次施工中的人、机、料、法、环具体要素，实现质量进度的全面感知，数据的智能分析与共享，质量提升的协同管理。</span>
            </div>
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/1-4.png" />
              <p>无人化</p>
              <span>通过物联网远程自动采集数据，无需人工现场检测作业；通过大数据智能分析，无需人工处理数据；通过数据实时共享协同，实现检测数据与结果的自动发布。</span>
            </div>
          </template>
          <template v-if="bannerIndex==2">
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/2-1.png" />
              <p>专业</p>
              <span>采用微动侦测技术对锚固单元的微运动过程进行动态跟踪与快速识别，对既有锚固锁定状态不产生扰动影响，操作过程既安全又专业。</span>
            </div>
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/2-2.png" />
              <p>精确</p>
              <span>测量系统采用高精度传感器组件，控制系统采用伺服闭环反馈策略，测量精度经国家法定计量机构进行校准测试和检定确认。</span>
            </div>
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/2-3.png" />
              <p>高效</p>
              <span>检测操作中，根据预设参数，系统以最优策略匹配运行参数，并自动完成数据的采集、处理、分析工作，单孔检测耗时低于 1 分钟。</span>
            </div>
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/2-4.png" />
              <p>可靠</p>
              <span>对系统机、电、液、控等核心部件，采用了集成化设计和模块化封装，运行平稳，故障率低，运维便捷。依托智能算法进行数据分析处理，结果客观真实。</span>
            </div>
          </template>

          <template v-if="bannerIndex==3">
            <div class="product2-li" >
              <img src="@/assets/imgs/product/icon/3-1.png" />
              <p>经典</p>
              <span>采用经典力学原理，技术方法直观可靠。</span>
            </div>
            <div class="product2-li"  >
              <img src="@/assets/imgs/product/icon/3-2.png" />
              <p>独立</p>
              <span>测控系统独立工作，可有效避免干扰因素。</span>
            </div>
            <div class="product2-li"  >
              <img src="@/assets/imgs/product/icon/3-3.png" />
              <p>便捷</p>
              <span>软硬件设计高度模块化，安装操作便捷直观。</span>
            </div>
            <div class="product2-li"  >
              <img src="@/assets/imgs/product/icon/3-4.png" />
              <p>灵活</p>
              <span>配置灵活度高，可适应于各种工况下预应力测试需求。</span>
            </div>
          </template>

          <template v-if="bannerIndex==4">
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/4-1.png" />
              <p>全自动</p>
              <span>预设参数后，在锚索预应力施加过程中，自动运行并完成张拉加载、稳压持荷和卸载锚固功能，有效避免了人工因素干扰。</span>
            </div>
            <div class="product2-li" >
              <img src="@/assets/imgs/product/icon/4-2.png" />
              <p>高精度</p>
              <span>张拉力值采用传感器实时测量，动作执行机构采用伺服闭环策略进行反馈控制，运行状态平稳且切换无冲击。实际控制精度（法定计量：1%FS）远高于人工读取油压表（约 10%）进行手动操控精度。</span>
            </div>
            <div class="product2-li" >
              <img src="@/assets/imgs/product/icon/4-3.png" />
              <p>自适应</p>
              <span>根据预设的工艺参数，在预应力张拉过程中，动态调整运行参数（如加载速率、持荷时间、卸载速率等）。能充分保证预应力在锚索锚固体系内有效传递，适应协调变形，进而真正做到预应力在锚索上能“加得上、停得稳和锁得住”。</span>
            </div>
            <div class="product2-li" >
              <img src="@/assets/imgs/product/icon/4-4.png" />
              <p>数字化</p>
              <span>预应力张拉施工，采用标准参数预设和全自动运行，实现了预应力张拉施工中设备操作、数据测量、结果记录等工作的全程数字化，数据客观真实可信，可从根本上规范施工管理过程。</span>
            </div>
          </template>

          <template v-if="bannerIndex==5">
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/5-1.png" />
              <p>多通道高兼容</p>
              <span>可同时连接并测量多路传感器，普遍兼容适应市面上各类型号的工程监测传感器。</span>
            </div>
            <div class="product2-li" >
              <img src="@/assets/imgs/product/icon/5-2.png" />
              <p>低功耗运行使用</p>
              <span>采用低功耗采集传输技术，最大程度保护传感器，延长传感器使用寿命。</span>
            </div>
            <div class="product2-li">
              <img src="@/assets/imgs/product/icon/5-3.png" />
              <p>柔性配置稳定监测</p>
              <span>可针对不同需求类型及传感器类型进行工作参数的灵活配置。</span>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="product3" :style="{'background':bannerIndex==1?'':'#ffffff'}">
      <div class="header-title">产品价值</div>

      <template v-if="bannerIndex==1">
        <div class="product3-ul">
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/1-5.png" />
              <span class="sp1">施工过程在线化</span>
              <span  class="sp2">将工程项目设计文件、现场施工、质量验收等重点环节，通过智能硬件进行实时采集，实现过程全链感知。</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/1-6.png" />
              <span class="sp1">协同作业网络化</span>
              <span  class="sp2">以在线化的施工过程数据为基础，集成各个子系统的应用于平台，实现随时随地的网络化协同作业。</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/1-7.png" />
              <span class="sp1">监管方式智慧化</span>
              <span  class="sp2">云平台及终端聚合了先进的智能判断和分析策略，有效帮助相关方聚焦关键问题，主动规避风险，优化执行操作，进而提升质量监管水平。</span>
          </div>
        </div>
      </template>
      <template v-if="bannerIndex==2">
        <div class="product3-uls">
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/2-5.png" />
            <span class="sp4">原理科学</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/2-6.png" />
            <span class="sp4">测量精确</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/2-7.png" />
            <span class="sp4">操作高效</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/2-8.png" />
            <span class="sp4">安全可靠</span>
          </div>
        </div>
      </template>
      <template v-if="bannerIndex==3">
        <div class="product3-uls">
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/3-5.png" />
            <span class="sp4">可靠性好</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/3-6.png" />
            <span class="sp4">实用性强</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/3-7.png" />
            <span class="sp4">灵活度高</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/3-8.png" />
            <span class="sp4">适应性广</span>
          </div>
        </div>
      </template>
      <template v-if="bannerIndex==4">
        <div class="product3-uls">
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/4-5.png" />
            <span class="sp4">操作简便</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/4-6.png" />
            <span class="sp4">控制精确</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/4-7.png" />
            <span class="sp4">专业高效</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/4-8.png" />
            <span class="sp4">客观真实</span>
          </div>
        </div>
      </template>
      <template v-if="bannerIndex==5">
        <div class="product3-uls">
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/5-4.png" />
            <span class="sp4">低成本使用运维</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/5-2.png" />
            <span class="sp4">低功耗运行</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/5-1.png" />
            <span class="sp4">高兼容性接入</span>
          </div>
          <div class="product3-li">
            <img src="@/assets/imgs/product/icon/5-6.png" />
            <span class="sp4">高效率采集传输</span>
          </div>
        </div>
      </template>
    </div>

    <div class="product4">
      <div class="product4-left">
        <img src="@/assets/imgs/solution/5.png"  style="position:absolute;width: 300px;right: 0;bottom: 0;">
      </div>
      <el-carousel height="9.84rem" class="product4-right" :indicator-position="'none'">
        <el-carousel-item v-for="item in projectList" >
          <img style="    width: 100%;height: 100%;object-fit: cover;" @click="toPape(item)" :src="item.cover" />
        </el-carousel-item>
      </el-carousel>
      <div class="product4-box">

        <div class="product4-t1">应用场景。</div>
        <div class="product4-t2" v-if="bannerIndex==1">公路、铁路、市政建设等规模大、数量多、分布广、工点散的线性工程，
          建立中心型数据平台进行集群化质量管控。</div>
        <div class="product4-t2" v-if="bannerIndex==2">桥梁、边坡、基坑、隧道等工程锚下预应力的快速准确检测。
        </div>
        <div class="product4-t2" v-if="bannerIndex==3">桥梁、边坡、基坑、隧道等工程的预应力损失试验、摩阻试验、张拉工艺试验与验证等。
        </div>
        <div class="product4-t2" v-if="bannerIndex==4">桥梁、边坡、基坑、隧道等工程的预应力施加、拉拔性试验等。</div>
        <div class="product4-t2" v-if="bannerIndex==5">岩土工程、结构工程中预埋传感器短期及中长期监测。</div>
        <div class="product4-more" @click="$router.push({path:'/case'})">查看案例</div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>


<script>
  import headers from "@/components/wap/header1"
  import footers from "@/components/wap/footer"
  import axios from "axios";
  export default {
    name: 'wapProduct',
    components:{headers,footers},
    data() {
      return{
        projectList:[],
        bannerIndex:1,
        selectIndex1:1,
        productIndex:1,
      }
    },
    mounted() {
      this.getProjectcList();
      if(this.$route.query.index){
        this.bannerIndex= this.$route.query.index
      }
    },
    beforeDestroy() {
    },
    methods:{
      //获取案例项目
      getProjectcList() {
        axios.get(this.pageUrl + `/project-case/page?pageNo=${this.selectIndex1}&pageSize=200`).then(res => {
          this.projectList = res.data.data.list;

        })
      },
    }
  }
</script>

<style scoped>
  .banner-box{
    width: 100%;
    height: 13.34rem;
    text-align: center;
    padding-top: 1rem;
  }
  .banner-box p{
    font-size: 0.48rem;
    line-height: 2.4;
    margin-top: 1.38rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #0071EF;
  }
  .banner-box img{
    width: 6rem;margin-top: 2rem
  }
  .product1{
    padding:0.2rem 0.72rem 0.7rem;
    width: 100%;
    box-sizing: border-box;
    background-color: #F2F4F9;
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
  }
  .product1 .title{
    font-size: 0.28rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    margin: 0.4rem 0 0.1rem 0;
  }
  .product2{
    padding:0.6rem 0.72rem 0.7rem;
  }
  .product2 .header-title,.product3 .header-title{
    text-align: center;
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    margin-bottom: 0.2rem;
    color: #19203B;
  }

  .product2 .product2-li{
    background: #F1F3F9;
    border-radius: 0.08rem;
    text-align: center;
    padding-bottom: 0.4rem;
    margin-bottom: 0.2rem;
  }
  .product2 .product2-li img{
    width: 1.4rem;
    margin-top: 0.3rem;
  }
  .product2 .product2-li p{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }
  .product2 .product2-li span{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    width: 5.4rem;
    margin: 0.1rem auto;
    display: block;
    line-height: 2;
    text-align: left;
    color: #5C5D5F;
  }

  .product3{
    padding:0.6rem 0.72rem 0.7rem;
    background-color: #F1F3F9;
  }
  .product3-li{
    text-align: center;
  }
  .product3-li img{
    width: 1.4rem;
    display: block;
    text-align: center;
    margin: 0 auto;
  }
  .product3-li .sp1{
    font-size: 0.28rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    margin-top: 0.2rem;
    display: block;
  }
  .header-gong{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
    letter-spacing: 3px;
  }
 .product3-li .sp2{
    width: 6.06rem;
   text-align: left;
   letter-spacing: 0.01rem;
    font-size:0.24rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
   display: block;
   line-height: 2;
   margin-top: 0.1rem;
  }
  .product3-uls{
    display: grid;
    grid-template-columns:repeat(2,1fr);
    grid-gap: 0.4rem;
  }
  .product3-uls .sp4{
    font-size: 0.28rem;
    display: block;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #19203B;
  }
  .product4{
    margin-bottom: 0.8rem;
    position: relative;
  }

  .product4-box{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    box-sizing: border-box;
    padding:4rem 0.3rem 0;
    margin: 0 auto;
    text-align: left;
    z-index: 9;
    background-color: rgba(25, 32, 59, 0.3);
  }
  .product4-more{
    width: 1.36rem;
    height: 0.42rem;
    background: linear-gradient(33deg, #34E4AA 0%, #2C68FF 100%);
    border-radius: 88px 88px 88px 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 7.4rem;
    font-size: 0.2rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/view/product/wapIndex.vue